import { useApi } from "./api";
import { useContextState } from '../context/Context';
// import { Inbox } from "../models"; // Import models
// import { InboxAction } from "../context/Reducers"; // Import action types for safety

export const useMessagesApi = () => {
    const { $post, $get } = useApi();
    const { accountCTX } = useContextState();
    const { signedIn } = accountCTX;

    /**
     * Fetches a paginated list of inboxes for a given type.
     * This function is now DECOUPLED and simply returns the API response.
     * The component that calls it (InboxList.tsx) is responsible for dispatching.
     */
    const getInboxes = async (credentials: { type: string; page: number }) => {
        if (!signedIn) { return null; }
        // The credentials object is passed as query params by $get
        const data = await $get('messages/inbox/', true, credentials);
        // console.log('inboxes: ', data)
        return data; // Simply return the raw API response
    };

    /**
     * Fetches a paginated list of messages within a specific inbox.
     */
    const getMessages = async (credentials: { id: string; page: number }) => {
        if (!signedIn) { return null; }
        const data = await $get("messages/", true, credentials);
        return data?.results ? data : null;
    };

    /**
     * Sends a new message in a chat.
     */
    const sendMessage = async (credentials: FormData) => {
        if (!signedIn) { return null; }
        const data = await $post("messages/", credentials, true, false);
        return data;
    };

    /**
     * Creates a new support inbox/ticket.
     */
    const sendSupportMessage = async (credentials: { subject: string; message: string; type: string }) => {
        if (!signedIn) { return null; }
        // Assuming this endpoint creates a new support inbox
        const data = await $post("messages/inbox/", credentials, true);
        // This is a "write" action, but since it creates a whole new inbox that
        // will be fetched by the InboxList, we don't need to dispatch here.
        // The user will see it when the support list is refetched.
        return data;
    };

    return {
        getInboxes,
        getMessages,
        sendMessage,
        sendSupportMessage
    };
};